module.exports = __webpack_public_path__ + "static/client18-d63c6db036242aed080eb8c89937e148.png";